import Vue from "vue";

export default Vue.component("address-header", {

    template: `
        <div>
            <template v-if="address">
                <div v-if="address.name1">{{ address.name1 }}</div>
                <p class="sub" v-if="address.name1">{{ $translate("Phywe::Template.addressExtension") }}</p>

                <div v-if="address.name4">{{ address.name4 }}</div>
                <p class="sub" v-if="address.name4">{{ $translate("Phywe::Template.addressExtension") }}</p>

                <div v-if="address.address3">
                    {{ address.address3 }}
                </div>
                <p class="sub" v-if="address.address3">{{ $translate("Phywe::Template.addressExtension") }}</p>

                <div v-if="address.address4">
                    {{ address.address4 }}
                </div>
                <p class="sub" v-if="address.address4">{{ $translate("Phywe::Template.addressExtension") }}</p>

                <template v-if="isAddressFieldEnabled('title') || isAddressFieldEnabled('name2') || isAddressFieldEnabled('name3')">
                    <div class="font-bold">
                        <template v-if="isAddressFieldEnabled('title')">{{ address | optionType(11) }}</template>
                        <template v-if="isAddressFieldEnabled('name2')"> {{ address.name2 }}</template>
                        <template v-if="isAddressFieldEnabled('name3')"> {{ address.name3 }}</template>
                    </div>
                </template>
                <p class="sub">{{ $translate("Ceres::Template.addressFirstName") }} / {{ $translate("Ceres::Template.addressLastName") }}</p>

                <div v-if="isAddressFieldEnabled('address1') || isAddressFieldEnabled('address2')">
                    <template v-if="isAddressFieldEnabled('address1')">{{ address.address1 }}</template>&nbsp;<template v-if="isAddressFieldEnabled('address2')">{{ address.address2 }}</template>
                </div>
                <p class="sub" v-if="isAddressFieldEnabled('address1') || isAddressFieldEnabled('address2')">{{ $translate("Ceres::Template.addressStreet") }}</p>

                <div v-if="isAddressFieldEnabled('postalCode') || isAddressFieldEnabled('town')">
                    <template v-if="isAddressFieldEnabled('postalCode')">{{ address.postalCode }}</template>
                    <template v-if="isAddressFieldEnabled('town')"> {{ address.town }}</template>
                </div>
                <p class="sub" v-if="isAddressFieldEnabled('postalCode') || isAddressFieldEnabled('town')">{{ $translate("Ceres::Template.addressZip") }} / {{ $translate("Ceres::Template.addressPlace") }}</p>

                <div v-if="isAddressFieldEnabled('country')">{{ getCountryName(address.countryId) }}</div>
                <p class="sub" v-if="isAddressFieldEnabled('country')">{{ $translate("Ceres::Template.headerCountry") }}</p>

                <template v-for="option in address.options">
                    <div v-if="option.typeId == '1'" v-html="option.value"></div>
                    <p class="sub" v-if="option.typeId == '1' && option.value !== ''">
                        {{ $translate("Ceres::Template.contactVatNumber") }}
                    </p>
                </template>
            </template>
        </div>
    `,

    props: {
        template: {
            type: String,
            default: "#vue-address-header"
        },
        address: {
            type: Object,
            required: true
        },
        addressFields:
        {
            type: Array,
            default: () =>
            {
                return [
                    "email",
                    "title",
                    "contactPerson",
                    "name1",
                    "name2",
                    "name3",
                    "name4",
                    "address1",
                    "address2",
                    "address3",
                    "address4",
                    "postalCode",
                    "town",
                    "country",
                    "state"
                ];
            }
        }
    },

    methods:
    {
        getCountryName(countryId)
        {
            return this.$store.getters.getCountryName(countryId);
        },

        getStateName(countryId, stateId)
        {
            return this.$store.getters.getStateName(countryId, stateId);
        },

        isAddressFieldEnabled(fieldName)
        {
            return this.addressFields.includes(fieldName);
        }
    },

    filters:
    {
        optionType(selectedAddress, typeId)
        {
            // TODO DUPLICATE (Address Select) - move to vuex
            if (selectedAddress && selectedAddress.options)
            {
                for (const optionType of selectedAddress.options)
                {
                    if (optionType.typeId === typeId)
                    {
                        return optionType.value;
                    }
                }
            }

            return "";
        }
    }
});
